import { AppConfigProvider } from '@hmpu/powerups.config.app.provider';
import { GameWrapper } from './components/GameWrapper';
import { AppPages } from './components/AppPages/AppPages';
import { appConfig, globalContexts } from './config/app';
import './App.css';

function App() {
  return (
    <AppConfigProvider config={appConfig} globalContexts={globalContexts}>
      <GameWrapper>
        <AppPages>
          {Object.entries(appConfig.pageComponents).map(
            ([pageKey, PageComponent]: any) => (
              <PageComponent key={pageKey} />
            )
          )}
        </AppPages>
      </GameWrapper>
    </AppConfigProvider>
  );
}

export default App;
